import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-navy-900 text-cream-100 min-h-[90vh] flex items-center overflow-hidden pt-20 pb-16 lg:pt-0 lg:pb-0" data-id="element-46">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-47">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-48">
          <path d="M0,50 Q25,30 50,50 T100,50" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-49" />
          <path d="M0,60 Q25,40 50,60 T100,60" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-50" />
          <path d="M0,70 Q25,50 50,70 T100,70" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-51" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-52">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-54">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-tight mb-6 text-cream-50" data-id="element-55">
              The <span className="text-gold-500 italic" data-id="element-56">Cortisol Reset</span>{' '}
              Protocol
            </h1>
            <p className="text-lg md:text-xl text-cream-300 mb-10 font-light leading-relaxed" data-id="element-57">
              End the "Tired-but-Wired" cycle and reclaim deep, restorative
              sleep in 7 days—without giving up your morning coffee.
            </p>
            <motion.a href="#offer-price" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-gold-500 hover:bg-gold-400 text-navy-900 font-medium px-8 py-4 rounded-sm transition-colors duration-300 text-lg tracking-wide shadow-[0_0_20px_rgba(201,169,110,0.3)]" data-id="element-58">
              Get the Protocol Now
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-59">
            <div className="absolute inset-0 bg-gold-500/10 blur-3xl rounded-full transform -translate-y-10" data-id="element-60"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ihVeVKS6mg2xzSnDj9ssrf/heylloyd-image-1774894106555.png" alt="The Cortisol Reset Protocol on Tablet" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl rounded-xl" data-id="element-61" />
          </motion.div>
        </div>
      </div>
    </section>;
}